import React from 'react';
import { PlusIcon, CorrectIcon } from '@aisales/react-ui-kit';

export const lastDashboardTabs = [
  {
    text: <PlusIcon />,
    floating: true,
  },
];
